import alertify from "alertifyjs";
import DOMPurify from "dompurify";
import "alertifyjs/build/css/alertify.css";
import "alertifyjs/build/css/themes/default.css";
import "css/alertify.css";
// TODO: Replace AlertifyJS with something aimed at React

const purifyConfig = {
  ALLOWED_TAGS: ["b", "br", "i"],
  ALLOWED_ATTR: ["class"] // class is used with the 'i' tag to specify an icon
};

const namedItemSaved = (name) => {
  return successTemplated("'<b>{name}</b>' saved.", {"{name}": name});
};

const namedItemUpdated = (name) => {
  return successTemplated("'<b>{name}</b>' updated.", {"{name}": name});
};

const namedItemDeleted = (name) => {
  return successTemplated("'<b>{name}</b>' deleted.", {"{name}": name});
};

const changesSaved = () => {
  return success("Your changes have been saved.", "bottom-right");
};

const changesReset = () => {
  return success("Your changes have been reset.", "bottom-right");
};

const contactSupport = () => {
  return error("An error occurred.<br />Please contact support.");
};

/**
 * Displays an error popup with sanitized user data replacements
 * @param {string} messageTemplate - Message template with placeholders (e.g., "User {name} not saved")
 * @param {Object} placeholderToString - Object mapping placeholders to user data values
 */
const errorTemplated = (messageTemplate, placeholderToString, position = "bottom-right") => {
  let cleanMessage = messageTemplate;

  for (const placeholder in placeholderToString) {
    const cleanValue = DOMPurify.sanitize(placeholderToString[placeholder], {ALLOWED_TAGS: []});
    cleanMessage = cleanMessage.replace(placeholder, cleanValue);
  }

  return error(cleanMessage, position);
};

/**
 * Displays a success popup with sanitized user data replacements
 * @param {string} messageTemplate - Message template with placeholders (e.g., "User {name} saved")
 * @param {Object} placeholderToString - Object mapping placeholders to user data values
 */
const successTemplated = (messageTemplate, placeholderToString, position = "bottom-right") => {
  let cleanMessage = messageTemplate;

  for (const placeholder in placeholderToString) {
    const cleanValue = DOMPurify.sanitize(placeholderToString[placeholder], {ALLOWED_TAGS: []});
    cleanMessage = cleanMessage.replace(placeholder, cleanValue);
  }

  return success(cleanMessage, position);
};

const error = (message, position = "bottom-right") => {
  const cleanMessage = DOMPurify.sanitize(message, purifyConfig);
  alertify.set("notifier", "position", position);
  return alertify.error(cleanMessage);
};

const success = (message, position = "bottom-right") => {
  const cleanMessage = DOMPurify.sanitize(message, purifyConfig);
  alertify.set("notifier", "position", position);
  return alertify.success(cleanMessage);
};

const warning = (message, position = "bottom-right") => {
  const cleanMessage = DOMPurify.sanitize(message, purifyConfig);
  alertify.set("notifier", "position", position);
  return alertify.message(cleanMessage);
};

export {
  error,
  success,
  warning,
  contactSupport,
  changesSaved,
  changesReset,
  errorTemplated,
  successTemplated,
  namedItemSaved,
  namedItemUpdated,
  namedItemDeleted
};
